import React, { memo } from "react";

//internal deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { DELIVERY_SPEED_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";

//styles
import { IMAGE_WIDTH, NudgeContainer, NudgeImageWrapper, NudgeText } from "./styles";

//helpers
import { isEmpty } from "@swiggy-private/js-utils";

//types
import { DeliverySpeedNudgeProps } from "./types";

function DeliverySpeedNudge(props: DeliverySpeedNudgeProps) {
    const { nudge, isCrossSell, isCashback } = props;
    if (isEmpty(nudge) || isEmpty(nudge.message)) {
        return null;
    }

    return (
        <NudgeContainer
            data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_NUDGE}
            isCrossSell={isCrossSell}
            isCashback={isCashback}
        >
            {!isEmpty(nudge.icon) && (
                <NudgeImageWrapper isCashback={isCashback}>
                    <Image
                        cloudinaryId={nudge.icon}
                        width={`${IMAGE_WIDTH}px`}
                        cloudinaryWidth={!isCashback ? IMAGE_WIDTH * 2 : undefined}
                    />
                </NudgeImageWrapper>
            )}
            <NudgeText
                color="text_High_Emphasis"
                variant="V2.body2.neutral.medium"
                isCrossSell={isCrossSell}
                dangerouslySetInnerHTML={{
                    __html: nudge.message,
                }}
                isCashback={isCashback}
            />
        </NudgeContainer>
    );
}

export default memo(DeliverySpeedNudge);
